import { schemaCommon } from "common/bit/form/FormikSchema"
import * as yup from "yup"

export const schema = yup
  .object({
    fullName: schemaCommon.fullName,
    phoneNumber: schemaCommon.phoneNumber,
    email: schemaCommon.email,
    licenseNumber: schemaCommon.licenseNumber,
    message: yup.string().max(500, "יש להזין עד 500 תווים בלבד"),
  })
  .defined()

export const initialFormState: yup.InferType<typeof schema> = {
  fullName: "",
  phoneNumber: "",
  email: "",
  licenseNumber: "",
  message: "",
}
